import p from './verification-code-log.vue';

export default p;
